import { render, staticRenderFns } from "./sortNum.vue?vue&type=template&id=03175b7c&"
import script from "./sortNum.vue?vue&type=script&lang=js&"
export * from "./sortNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports